import * as React from "react";
import styled from "styled-components";
import Select from "react-select";

function DashboardHeader({ title, menuOptions, currentView, setCurrentView }) {
  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{title}</HeaderTitle>
        <SelectContainer>
          <Select
            options={menuOptions}
            isLoading={false}
            value={
              currentView
                ? menuOptions.find(obj => obj.value === currentView)
                : null
            }
            onChange={(opt: ISelectOption) => setCurrentView(opt.value)}
            clearable={false}
            searchable={false}
          />
        </SelectContainer>
      </HeaderContainer>
    </>
  );
}

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: top;
  flex-direction: row;
  margin-bottom: 10px;
`;

const HeaderTitle = styled.div`
  font-size: 24px;
`;

const SelectContainer = styled.div`
  min-width: 200px;
`;

export default DashboardHeader;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DashboardHeader.tsx